<template>
	<div>
		<div v-show="isFirst">
			<div style="margin-top: 20px;">
				<el-row  :gutter="12">
					<el-col :span="8">
						<el-select v-model="statusSelect" @change="statusChange" style="width: 110px;">
							<el-option label="全部状态" value="0"></el-option>
							<el-option label="审批中" value="1"></el-option>
							<el-option label="审批通过" value="2"></el-option>
							<el-option label="审批拒绝" value="3"></el-option>
						</el-select>
						<el-button @click="allConfirm(true)" type="success" style="margin-left: 3px;" v-if="isBrand">批准</el-button>
						<el-button @click="allConfirm(false)" type="danger" style="margin-left: 3px;" v-if="isBrand">拒绝</el-button>
					</el-col>
					<el-col :span="16">
						<div style="width: 100%;text-align: right;">
							<el-select style="width: 110px;margin-left: 3px;" v-model="selectValue" placeholder="请选择">
								<el-option label="代理商" value="1" v-if="isBrand"></el-option>
								<el-option label="联系人" value="2"></el-option>
								<el-option label="客户名称" value="3"></el-option>
								<el-option label="退单单ID" value="4"></el-option>
								<el-option label="退单日期" value="5"></el-option>
							</el-select>
							<el-input type="text" style="width:255px;margin-left: 3px;" v-model="queryValue" v-if="isInput" placeholder="请输入"></el-input>
							<el-date-picker
								style="width: 255px;margin-left: 3px;"
								v-if="!isInput"
								v-model="time"
							    type="daterange"
							    range-separator="至"
							    start-placeholder="订单开始日期"
							    end-placeholder="订单结束日期"
							    format="yyyy-MM-dd">
							</el-date-picker>
							<el-button type="primary" style="margin-left: 3px;" icon="el-icon-search" @click="updateTable">搜索</el-button>
						</div>
					</el-col>
				</el-row>
			</div>
			<div style="margin-top: 10px;">
				<el-table ref="multipleTable" 
				 :data="tableData" 
				 style="width: 100%" 
				 element-loading-text="数据正在加载中" 
				 @selection-change="handleSelectionChange"
				 :header-cell-style="headClass"
			 	 :row-style="rowClass">
			      <el-table-column type="selection" width="60"></el-table-column>
			      <el-table-column prop="id" label="退单号" sortable></el-table-column>
                  <el-table-column prop="adminName" label="代理商" v-if="isBrand"></el-table-column>
			      <el-table-column label="状态">
			      	<template slot-scope="scope">
			      		<div>
			      			<span v-if="scope.row.status == 1">审批中</span>
			      			<span v-if="scope.row.status == 2">审批通过</span>
			      			<span v-if="scope.row.status == 3">审批拒绝</span>
			      		</div>
			      	</template>
			      </el-table-column>
			      <el-table-column prop="customerName" label="客户名称"></el-table-column>
			      <el-table-column prop="contact" label="联系人"></el-table-column>
			      <el-table-column prop="contactNumber" label="联系电话"></el-table-column>
			      <el-table-column label="安装地址">
			      	<template slot-scope="scope">
			      		<div>
			      			{{scope.row.province}} {{scope.row.city}} {{scope.row.district}} {{scope.row.address}}
			      		</div>
			      	</template>
			      </el-table-column>
			      <el-table-column prop="posttime" label="退单日期" :formatter="dateFormat"></el-table-column>
			      <el-table-column label="操作">
			      	<template slot-scope="scope">
			      		<button @click="getMessage(scope.row)">查看</button> 
			      	</template>
			      </el-table-column>
			    </el-table>
			    <el-pagination background
		    			style="text-align:right;margin-top: 15px;margin-bottom: 65px;"
			            @size-change="handleSizeChange"
			            @current-change="handleCurrentChange"
			            :current-page="currentPage"
			            :page-sizes="[10, 50, 100, 200]"
			            :page-size="pageSize" 
			            layout="total, sizes, prev, pager, next, jumper"
			            :total="total">
			    </el-pagination>
			</div>
		</div>
		<div v-show="!isFirst">
			<div style="margin-top: 20px;">
				<i class="el-icon-back" style="font-size: 16px;cursor:pointer;" @click="goback">查看详情</i>
			</div>
			<div style="margin-top: 25px;">
				<el-row>
					<el-col :span="18">
						<div>
							<table>
								<tr>
									<td>客户名称</td>
									<td class="tdClassForAccount">{{customerName}}</td>
								</tr>
								<tr>
									<td>联系人</td>
									<td class="tdClassForAccount">{{contact}}</td>
								</tr>
								<tr>
									<td>联系电话</td>
									<td class="tdClassForAccount">{{contactNumber}}</td>
								</tr>
								<tr>
									<td>安装地址</td>
									<td class="tdClassForAccount">
										<div>{{province}} {{city}} {{district}}</div>
										<div>{{address}}</div>
									</td>
								</tr>
								<tr>
									<td>退货理由</td>
									<td class="tdClassForAccount" style="color: red;">{{reason}}</td>
								</tr>
							</table>
						</div>
					</el-col>
					<el-col :span="6">
						<div>
							<div v-if="isReturn">
								<div style="margin-top: 28px;">
									<el-button @click="confirm(true)" type="success">批准</el-button>
								</div>
								<div style="margin-top: 10px;">
									<el-button @click="confirm(false)" type="danger">拒绝</el-button>
								</div>
							</div>
							<div v-if="!isReturn" style="font-size: 24px;color: red;margin-top: 50px;">
								<span v-if="status == 1">审批中</span>
				      			<span v-if="status == 2">审批通过</span>
				      			<span v-if="status == 3">审批拒绝</span>
							</div>
						</div>
					</el-col>
				</el-row>
			</div>
			<div>
				<el-table ref="returnTable" 
					key="returnTable"
				 :data="list" 
				 style="width: 100%" 
				 element-loading-text="数据正在加载中" 
				 :header-cell-style="headClass"
			 	 :row-style="rowClass">
			 	  <el-table-column prop="sn" label="设备条形码"></el-table-column>
			      <el-table-column prop="model" label="设备型号"></el-table-column>
			      <el-table-column label="图片">
			      	<template slot-scope="scope">
			      		<div>
			      			<img :src="scope.row.image" style="width: 30px;height: 30px;"/>
			      		</div>
			      	</template>
			      </el-table-column>
			      <el-table-column prop="expires" label="设备有效期" :formatter="dateFormat"></el-table-column>
			    </el-table>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'returnRecord',
  components: {
  },
  data() {
    return {
    	total: 0,
        currentPage: 1,
　　  	pageSize: 10,
		tableData:[],
		multipleSelection:[],
		myDialog:false,
		isFirst:true,
		statusSelect:"",
		selectValue:"",
		queryValue:"",
		time:[],
		isAgent:false,
		isBrand:false,
		id:'',
		address:"",
		city:"",
		contact:"",
		contactNumber:"",
		customerName:"",
		district:"",
		province:"",
		list:"",
		status:"",
		isReturn:false,
		reason:''
    }
  },
  watch: {
  },
  computed:{
  	isInput:function(){
  		if(this.selectValue != "4"){
  			this.queryValue = "";
  			return true;
  		}else{
  			return false;
  		}
  	}
  },
  mounted() {
  	var thiz = this;
	axios.get(this.$store.getters.getApiValue+'/srsUser/getMyData.do').then(function (response) {
			var data = response.data;
			if(data.status == "200"){
				if(data.data.role == "2" || data.data.role == "3"){
					thiz.isAgent = true;
				}else if(data.data.role == "4"){
					thiz.isBrand = true;
				}
			}else{
				thiz.$message.error(data.message);
			}
		}).catch(function (error) {
			thiz.$message.error("系统异常，请与管理员联系!");
			console.log(error);
		});
  	this.updateTable();
  },
  beforeDestroy() {
  },
  methods: {
  	allConfirm(flag){
  		var ids = "";
  		for(var i = 0;i < this.multipleSelection.length;i++){
  			if(this.multipleSelection[i].status == "1"){
  				ids = ids + this.multipleSelection[i].id + ",";
  			}
  		}
  		if(ids.length <= 0){
  			this.$message.error("请选择需审批的退单!");
  			return;
  		}
		var thiz = this;
		var str = "";
  		if(flag){
  			str = "确认批量批准退单号为"
  		}else{
  			str = "确认批量拒绝退单号为"
  		}
  		this.$confirm(str+ids.substring(0,ids.length-1)+'吗?')
  			.then(_ => {
	        	axios.get(thiz.$store.getters.getApiValue+'/application/verifyReturn.do',{
					params:{
						returnids:ids.substring(0,ids.length-1),
						ispass:flag
					}
				}).then(function (response) {
				    var data = response.data;
				    if(data.status == "200"){
				    	thiz.$message.success("审批退单成功!");
				    	thiz.updateTable();
				    }else{
						thiz.$message.error(data.message);
					}
				  }).catch(function (error) {
				  	thiz.$message.error("系统异常，请与管理员联系!");
				    console.log(error);
				  });
			}).catch(_ => {});
  	},
  	handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  	handleSizeChange(val) {
      this.pageSize = val;
      this.updateTable();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.updateTable();
    },
    statusChange(){
    	this.updateTable();
    },
    updateTable(){
    	var params = {
  				pageId:this.currentPage,
  				size:this.pageSize
  			};
  		if(this.statusSelect != "0"){
  			params.status = this.statusSelect;
  		}
  		if(this.selectValue == "1" && this.queryValue != ""){
  			params.adminName = this.queryValue;
  		}else if(this.selectValue == "2" && this.queryValue != ""){
  			params.contact = this.queryValue;
  		}else if(this.selectValue == "3" && this.queryValue != ""){
  			params.customerName = this.queryValue;
  		}else if(this.selectValue == "4" && this.queryValue != ""){
  			params.returnid = this.queryValue;
  		}else if(this.selectValue == "5"){
  			if(this.time != null && this.time.length > 0){
		  		params.startDate = this.getStandardDate(this.time[0]);
		  		params.endDate = this.getStandardDate(this.time[1]);
		  	}
  		}
  		const loading = this.$loading({
          lock: true,
          text: '获取表格数据中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
          loading.close();
        }, 3000);
    	var thiz = this;
    	axios.get(this.$store.getters.getApiValue+'/application/searchReturn.do',{
  			params:params
  		}).then(function (response) {
  			loading.close();
		    var data = response.data;
		    if(data.status == "200"){
		    	thiz.total = data.totalCount;
		    	thiz.tableData = data.data;
		    }
		  }).catch(function (error) {
		  	loading.close();
		    console.log(error);
		  });
    },
    getMessage(row){
 	    this.title = "查看详情";
    	this.list = [];
    	var thiz = this;
    	axios.get(this.$store.getters.getApiValue+'/application/getReturn.do',{
  			params:{
  				returnid:row.id
  			}
  		}).then(function (response) {
		    var data = response.data;
		    if(data.status == "200"){
		    	thiz.id = data.data.id;
		    	thiz.address = data.data.address;
		    	thiz.city = data.data.city;
		    	thiz.contact = data.data.contact;
		    	thiz.contactNumber = data.data.contactNumber;
		    	thiz.customerName = data.data.customerName;
		    	thiz.district = data.data.district;
		    	thiz.province = data.data.province;
		    	thiz.status = data.data.status;
		    	thiz.reason = data.data.reason;
		    	if(!thiz.isAgent && thiz.status == "1"){
		    		thiz.isReturn = true;
		    	}
		    	var jsonList = JSON.parse(data.data.json);
		    	for(var i = 0;i < jsonList.length;i++){
		    		thiz.list.push(jsonList[i]);
		    	}
		    	thiz.isFirst = false;
		    }else{
				thiz.$message.error(data.message);
			}
		  }).catch(function (error) {
		  	thiz.$message.error("系统异常，请与管理员联系!");
		    console.log(error);
		  });
    },
    confirm(flag){
    	var thiz = this;
    	axios.get(this.$store.getters.getApiValue+'/application/verifyReturn.do',{
    		params:{
    			returnids:thiz.id,
    			ispass:flag
    		}
    	}).then(function (response) {
			    var data = response.data;
			    if(data.status == "200"){
			    	if(flag){
			    		thiz.status = "2";
						thiz.isReturn = false;
					}else{
						thiz.status = "3";
						thiz.isReturn = false;
					}
			    }else{
					thiz.$message.error(data.message);
				}
		  }).catch(function (error) {
		  	thiz.$message.error("系统异常，请与管理员联系!");
		    console.log(error);
		  });
    },
    dateFormat(row,column){
		var str = row[column.property];
		if(str == null || str == ""){
			return "";
		}else{
			return this.getStandardDate(new Date(str));
		}
	},
	getStandardDate(val){
    	var year = val.getFullYear();
        var month = val.getMonth() + 1;
        var day = val.getDate();
        month = month < 10 ? "0"+month : month;
        day = day < 10 ? "0"+day : day;
        return year+"-"+month+"-"+day;
   	},
    headClass({ row, rowIndex}) {
    	if(rowIndex == 0){
    		return ''
    	}
	    return ''
	},
	goback(){
   		this.isFirst = true;
   		this.isReturn = false;
   		this.customerName = "";
   		this.id = "";
   		this.address = "";
   		this.city = "";
   		this.contact = "";
   		this.contactNumber = "";
   		this.district = "";
   		this.province = "";
   		this.status = "";
   		this.list = [];
   		this.reason = "";
   		this.updateTable();
   	},
    rowClass({ row, rowIndex}) {
	    if(rowIndex%2 == 0){
	    	return 'background:#F1F2F7;'
	    }else{
	    	return 'background:white;'
	    }
	    return ''
	}
  }
}
</script>

<style>
  .el-table{
  	font-size: 12px;
  	border-bottom: 1px solid #dcd8d8;
  	color: black;
  }
  .el-table tr th{
  	border-top: 0px;
  	border-left: 0px;
  	border-right: 0px;
  }
  .el-table tr td{
  	border-bottom: 1px solid #dcd8d8;
  }
  .tdClassForAccount{
  	padding-left: 10px;
  }
</style>